import { ActivatedRoute } from '@angular/router';
import { ParkerClient, LinkParkerToUserDTO, UserInfoDTO, LinkedParkerDTO, UserAccountClient, LinkParkerToUserResultDTO } from './../../base/models/models.swagger.generated';
import { SpinnerService } from './../../base/spinner/spinner.service';
import { AuthService } from '../../base/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { TitleBarComponent } from '../../base/shared/title-bar/title-bar.component';
import { AppErrorMessagesService } from 'src/app/base/services/app-error-messages.service';
import { catchError, of } from 'rxjs';

@Component({
    selector: 'app-link-parker-to-user',
    templateUrl: './link-parker-to-user.component.html',
    styleUrls: ['./link-parker-to-user.component.scss'],
    imports: [TitleBarComponent, GridModule, TranslateModule]
})
export class LinkParkerToUserComponent implements OnInit {
  public isUserAllowedToLinkParker: boolean;
  public linkFailed = false;
  public linkSuccessful = false;
  public linkedParkers: LinkedParkerDTO[];
  public parkerName = '';
  public companyName = '';

  public get errorTranslationString() {
    return this.apiErrorCode != null ?  "i18n.domain.link-parker-to-user.message.api-error.MultipleParkersOnSameCompanyOrClientNoAllowed" : "i18n.domain.link-parker-to-user.message.link-failed";
  }

  private apiErrorCode: string | null = null;
  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private spinnerService: SpinnerService,
    private parkerClient: ParkerClient,
    private userAccountClient: UserAccountClient) { }

  ngOnInit() {
    this.isUserAllowedToLinkParker = this.authService.isUserStandardUser();
    if (this.isUserAllowedToLinkParker) {
      const userLinkCode = this.activatedRoute.snapshot.queryParams.code;
      this.spinnerService.show();
      this.apiErrorCode = null;
      this.parkerClient.linkParkerToUser(new LinkParkerToUserDTO({userLinkCode})).pipe(
        catchError((error: any) => {
          this.spinnerService.hide();
          this.apiErrorCode = AppErrorMessagesService.getApiErrorCode(error);
          this.linkFailed = true;
          return of(null);
        }
      )).subscribe({
        next: (result: LinkParkerToUserResultDTO) => {
          if (!result || !result.success) {
            this.linkFailed = true;
            this.spinnerService.hide();
          }
          else {
            this.parkerName = result.parker.firstName + ' ' + result.parker.lastName;
            this.companyName = result.parker.company?.name;
            this.userAccountClient.info().subscribe({
              next: (info: UserInfoDTO) => {
                this.spinnerService.hide();
                this.linkedParkers = info.linkedParkers;
                this.linkSuccessful = true;
              },
              error: (error: any) => {
                this.spinnerService.hide();
                this.linkFailed = true;
              }
            });
          }
        }, error: (error: any) => {
          this.spinnerService.hide();
          this.apiErrorCode = AppErrorMessagesService.getApiErrorCode(error);
          this.linkFailed = true;
        }
      });
    }
  }

  public getCompanyName(parker: LinkedParkerDTO): string {
    return parker.company?.name ?? parker.client?.name ?? '';
  }

}
